<template>
    <form class="max-w-3xl">
        <div class="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2" v-if="streamChapter">
            <form-field-text
                class="sm:col-span-2"
                id="stream-chapter-title"
                label="Title"
                field="stream_chapter_title"
                :value="streamChapter.stream_chapter_title"
                @update="updateStreamChapterField"
            ></form-field-text>
            <form-field-date-time
                class="sm:col-span-2"
                id="stream-chapter-starts"
                label="Starts"
                field="stream_chapter_starts"
                :value="streamChapter.stream_chapter_starts"
                @update="updateStreamChapterField"
            ></form-field-date-time>
        </div>
        <div class="mt-10">
            <alert-error class="-mt-4 mb-5" :alert="error" :onDismiss="clearError"></alert-error>
            <div class="flex flex-row">
                <button-regular
                    buttonColor="bg-white text-black border border-zinc-200 hover:border-zinc-300 focus-visible:outline-zinc-600"
                    buttonText="Cancel"
                    :buttonClick="cancel"
                ></button-regular>
                <div class="grow"></div>
                <button-primary buttonText="Save" :buttonDisabled="buttonDisabled" :buttonClick="save"></button-primary>
            </div>
        </div>
    </form>
</template>

<script>
import {mapState, mapActions} from 'pinia';

export default {
    name: 'FormStreamChapterEdit',
    emits: ['closed'],
    computed: {
        ...mapState(useStoreStreamChapter, {
            streamChapter: 'streamChapter',
            disabled: 'disabled',
            error: 'error',
        }),
        buttonDisabled() {
            if (this.disabled) return true;
            return !this.streamChapter?.stream_chapter_title || !this.streamChapter?.stream_chapter_starts;
        },
    },
    methods: {
        ...mapActions(useStoreStreamChapter, {
            updateStreamChapterField: 'updateStreamChapterField',
            patchStreamChapter: 'patchStreamChapter',
            clearError: 'clearError',
        }),
        cancel() {
            this.$emit('closed');
        },
        save() {
            this.patchStreamChapter().then(() => {
                if (!this.error) this.$emit('closed');
            });
        },
    },
};
</script>
